import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import classNames from 'classnames'
import mapDispatchers from '../utilities/mapDispatchers'
import icons from '../enums/icons'
import Img from './Img'
import styles from './FacebookAuthButton.icss'

class FacebookAuthButton extends Component {
	constructor(props) {
		super(props)

		this.state = {
			showProgress: false
		}

		this.doAuthFacebookRedirectLogin = this.doAuthFacebookRedirectLogin.bind(this)
	}

	doAuthFacebookRedirectLogin() {
		this.setState({ showProgress: true })
		// doing this to remove the native event object which cannot be passed around in the saga or you'll get "Warning: This synthetic event is reused for performance reasons."
		this.props.authFacebookRedirectLogin()
	}

	render() {
		return (
			<Button
				classes={{ root: styles.button, label: styles.label }}
				fullWidth
				onClick={this.doAuthFacebookRedirectLogin}
			>
				{this.state.showProgress &&
					<CircularProgress className={classNames(styles.logo, styles.facebookColour)} size={24} thickness={4} />
				}
				{!this.state.showProgress &&
					<Img className={styles.logo} content={icons.brandFacebook} />
				}

				<span className={styles.text}>{this.context.translate('Login with Facebook')}</span>
			</Button>
		)
	}
}

FacebookAuthButton.contextTypes = {
	translate: PropTypes.func
}

FacebookAuthButton.propTypes = {
	authFacebookRedirectLogin: PropTypes.func.isRequired
}

export default connect(
	null,
	/* istanbul ignore next line */
	dispatch => mapDispatchers(dispatch, ['authFacebookRedirectLogin'])
)(FacebookAuthButton)



// WEBPACK FOOTER //
// ./src/components/FacebookAuthButton.jsx